import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const headerBlurFlag = atom({
  key: 'headerBlurFlag',
  default: false,
  effects_UNSTABLE: [persistAtom],
})
